// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"258":"component---src-pages-home-index-tsx","532":"styles"}[chunkId] || chunkId) + "-" + {"231":"0051da622d1e93308732","258":"6916e34a79423df4b0df","532":"2442acdfd1e309ec47ff","610":"c07c4958367463bb3975","711":"bd0978904805edcc8930"}[chunkId] + ".js";
};